import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button, Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";

interface JobApplicationDetailsHeaderProps {
  jobPostId: string;
  title: string;
}

const JobApplicationDetailsHeader: React.FC<
  JobApplicationDetailsHeaderProps
> = ({ jobPostId, title }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnUrl = searchParams.get("returnUrl");
  const returnTab = searchParams.get("returnTab");
  const candidateId = searchParams.get("candidateId");

  const handleBack = () => {
    // If returnUrl is provided, use it directly (preserves filters, pagination, etc.)
    if (returnUrl) {
      try {
        const decodedUrl = decodeURIComponent(returnUrl);
        navigate(decodedUrl);
        return;
      } catch (e) {
        // If decoding fails, fall through to default logic
        console.error("Failed to decode returnUrl:", e);
      }
    }

    // Fallback: Navigate based on returnTab parameter
    switch (returnTab) {
      case "candidate-details":
        if (candidateId) {
          navigate(`/candidates/${candidateId}`);
        } else {
          navigate("/candidates");
        }
        break;
      case "candidates":
        navigate("/candidates");
        break;
      case "file-uploads":
        navigate(`/job-posts/${jobPostId}?tabIndex=file-uploads`);
        break;
      case "bulk-uploads":
        navigate(`/job-posts/${jobPostId}?tabIndex=bulk-uploads`);
        break;
      case "home":
        navigate("/");
        break;
      case "applied":
      case "applications":
        navigate(`/job-posts/${jobPostId}?tabIndex=applications`);
        break;
      default:
        // Default: if jobPostId exists, go to applications tab, otherwise go to home
        if (jobPostId) {
          navigate(`/job-posts/${jobPostId}?tabIndex=applications`);
        } else {
          navigate("/");
        }
        break;
    }
  };

  return (
    <div className="job-application-details-header">
      <div className="job-application-details-header-title-container">
        <Button
          onClick={handleBack}
          size="middle"
          type="text"
          icon={<ArrowLeftOutlined style={{ fontSize: "20px" }} />}
        />
        <Typography.Title level={4} style={{ margin: 0 }}>
          {title}
        </Typography.Title>
      </div>
    </div>
  );
};

export default JobApplicationDetailsHeader;
